module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "LavenderIcon.3d0bcaa8.svg";